import btgLogo from 'src/assets/icons/platforms/btg.svg'
import xpLogo from 'src/assets/icons/platforms/xp.svg'
import salesforceLogo from 'src/assets/icons/platforms/salesforce.svg'
import magnetcustomerLogo from 'src/assets/icons/platforms/magnetcustomer.avif'
import openFinanceLogo from 'src/assets/icons/platforms/openfinance.svg'

export const PLATFORMS = [
    { id: 'arquivos', label: 'Arquivos', available: true, logo: null },
    { id: 'open-finance', label: 'Open Finance', available: false, logo: openFinanceLogo },
    { id: 'btg', label: 'BTG Pactual', available: false, logo: btgLogo },
    { id: 'xp', label: 'XP Investimentos', available: false, logo: xpLogo },
    { id: 'salesforce', label: 'Salesforce', available: false, logo: salesforceLogo },
    { id: 'magnetcustomer', label: 'MagnetCustomer', available: false, logo: magnetcustomerLogo },
]

export const FILE_TYPES: Record<string, Array<{ id: string; label: string; description: string; available: boolean }>> = {
    arquivos: [
        { id: 'posicoes', label: 'Posições', description: 'Posições abertas das carteiras', available: true },
        { id: 'movimentacoes', label: 'Movimentações', description: 'Histórico de operações', available: true },
        { id: 'produtos', label: 'Produtos', description: 'Carteira de produtos', available: false },
    ],
}

export const FILE_TYPE_TO_API_TYPE: Record<string, 'positions' | 'movements'> = {
    posicoes: 'positions',
    movimentacoes: 'movements',
}
